import PropTypes from 'prop-types';
import { BsChevronRight, BsPauseCircle } from 'react-icons/bs';

export default function PauseTeaserCard({ title, onClick, disabled = false }) {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className="w-full rounded-card border border-primary-200 bg-primary-100 p-4 text-left transition-colors hover:border-primary-400 disabled:cursor-not-allowed disabled:opacity-60"
		>
			<div className="flex items-start gap-3">
				<BsPauseCircle className="mt-0.5 h-4 w-4 shrink-0 text-primary-600" />
				<div className="flex-1">
					<p className="text-sm font-semibold text-text">{title}</p>
					<p className="mt-0.5 text-sm text-bgBase-800">
						Bis zu 3 Monate ohne Kosten – Ihre Daten bleiben erhalten und Ihr Abo läuft danach automatisch
						weiter.
					</p>
				</div>
				<BsChevronRight className="h-4 w-4 shrink-0 self-center text-primary-600" />
			</div>
		</button>
	);
}

PauseTeaserCard.propTypes = {
	title: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};
